module.exports = __webpack_public_path__ + "static/media/xeinadin.b44f4c2a.png";